import * as React from "react";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import ServeurImg from "./dai_bascule.svg";

// import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { onSubmit, isVisible, message } = props;

  //
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "400px",
          backgroundColor: "unset",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background: "linear-gradient(45deg, #007ADF 10%, #00E1B3)",
            minHeight: "15px",
            borderTopLeftRadius: "0.2em",
            borderTopRightRadius: "0.2em",
          }}
        />
        <BoxGrid
          title={message ? "ERREUR SERVEURS" : "BASCULE SERVEURS"}
          classNames="boderShadow changed-btn-pwd animated slideInDown"
          error={false}
          onSubmit={onSubmit}
          BtnTextSpan={!message ? "OK" : null} // i18next.t("valider")
        >
          <Styled.CartContainer>
            <img src={ServeurImg} alt="Bascule serveurs" />
            <h1 style={{ margin: "2em 0 3em 0", padding: "0 25px" }}>
              {message && "Aucun serveur DAI ne répond."}
              {message && <br />}
              {message && "Veuillez contacter votre service informatique."}
              {!message &&
                "Suite à une bascule des serveurs, vous allez être redirigé automatiquement vers une nouvelle page de Tunnelwatch."}
            </h1>
          </Styled.CartContainer>
        </BoxGrid>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

Component.defaultProps = {};

interface ComponentInterface {
  onSubmit?: any;
  isVisible?: boolean;
  message?: string;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/healthCheck/component.tsx